import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

export const getDeliveryTypes = async (token, includeTerminated = false) => {
  log("welcome in getDeliveryTypes, includeTerminated=" + includeTerminated)

  if (!token || token === "") {
    return { error: true, message: "No token provided", delivery_types: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_delivery_types_api'
    const params = { include_terminated: includeTerminated }

    const result = await axios.get(url, { headers, params })
    log("result.data from getDeliveryTypes")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getDeliveryTypes")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching delivery types", delivery_types: [] }
  }
}

export const saveDeliveryType = async (token, deliveryTypeData) => {
  log("welcome in saveDeliveryType")
  log(deliveryTypeData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/save_delivery_type_api'

    const result = await axios.post(url, deliveryTypeData, { headers })
    log("result.data from saveDeliveryType")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in saveDeliveryType")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving delivery type" }
  }
}

export const deleteDeliveryType = async (token, deliveryTypeId) => {
  log("welcome in deleteDeliveryType for id=" + deliveryTypeId)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/delete_delivery_type_api'

    const result = await axios.post(url, { id: deliveryTypeId }, { headers })
    log("result.data from deleteDeliveryType")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in deleteDeliveryType")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting delivery type" }
  }
}

const useDeliveryTypesAPI = () => {
  return { error, getDeliveryTypes, saveDeliveryType, deleteDeliveryType }
}

export default useDeliveryTypesAPI
